import StepLayout from "../../components/StepLayout";
import { SQFForm, SQFStepOf } from "../../hooks/useServiceQuoteFlow";
import { useStore } from "@tanstack/react-form";
import { cn } from "@networx/utils/tailwind/cn";
import { isMobile } from "@/utils/is-mobile";

export default function AdditionalInfoStep({ step, form, onClickPrev }: Props) {
  const additionalInfo = useStore(form.store, (state) => state.values.additionalInfo);
  if (step?.hidden) return null;

  return (
    <StepLayout
      title={step.title}
      onClickPrev={onClickPrev}
      buttonProps={{ onClick: step.next, isDisabled: !step.canContinue(additionalInfo) }}
      classNames={{
        children: "sm:p-0"
      }}
    >
      <form.Field
        name="additionalInfo"
        validators={step.fields.additionalInfo.validators}
        listeners={{
          onChange: () => {
            if (step.autoForward) {
              step.resolve();
            }
          },
          onBlur: () => {
            if (isMobile()) {
              document.body.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
            }
          }
        }}
        children={(field) => {
          const inputProps = step.fields.additionalInfo.props(field);
          return (
            <textarea
              {...inputProps}
              onChange={(e) => inputProps.onValueChange(e.target.value)}
              placeholder="Type here"
              className={cn(
                "border-1 border-[#add2db] sm:border-[color:rgb(203,195,180)]",
                "h-[165px] sm:max-w-[320px]",
                "sm:rounded-small sm:w-96 sm:p-1",
                "text-[18px] text-[#666] sm:text-black shadow-[inset_0_1px_2px_rgba(0,0,0,0.2)] sm:shadow-none rounded-[6px] sm:rounded-[3px] w-full p-[10px]",
                "overflow-auto resize-none align-top font-display2 outline-none",
                "placeholder:text-[color:hsl(0,0%,75%)]",
              )}
              cols={30}
              rows={30}
            />
          )
        }
        }
      />
    </StepLayout>
  );
}


interface Props {
  step: SQFStepOf<"additional-info">;
  form: SQFForm;
  onClickPrev?: () => void;
}
